export const getBaseURL = (project) => envsBaseUrl[project][env]
export const getWebsiteURL = () => envsBaseUrl.website[env]
export const getApplicationUrl = () => applicationUrl[env]
export const getProfilesURL = () => profilesBaseUrl[env]
export const getTomTicketURL = () => tomTicketBaseUrl[env]
export const getGoogleAnalyticsTag = () => googleAnalyticsTag[env]
export const getMarketPlaceToken = () => marketPlaceToken[env]
export const getPaymentAuthKey = () => paymentAuthKey[env]
export const getMixPanelAuthKey = () => mixPanelAuthKey[env]
export const getGoogleRecaptchaToken = () => googleRecaptchaToken[env]
export const getEditorTyneMceToken = () => editorTyneMceToken[env]
export const getSentryDsn = () => sentryDsn[env]
export const getGoogleAuthenticationToken = () => googleAuthenticationToken[env]
export const getBaseCookiesCdnUrl = () => envsBaseUrl.cookiesCdn[env]
export const getBaseAgeGateCdnUrl = () => envsBaseUrl.ageGateCdn[env]
export const getMicrosoftClientId = () => microsoftClientId[env]
export const getDaiRagResourcesBaseUrl = () => envsBaseUrl.daiRagResources[env]
export const getGuestPortalWebUrl = () => envsBaseUrl.guestPortalWeb[env]
export const getDaiDisputesBaseUrl = () => envsBaseUrl.daiDisputes[env]

const env = process.env.REACT_APP_API || 'development'

export const isProduction = env === 'production'
export const isHomol = env === 'homol'
export const isSandbox = env === 'sandbox'
export const isDevelopment = env === 'development'
export const isProductionOrHomol = isProduction || isHomol

const envsBaseUrl = {
  dponet: {
    development: 'http://api.localhost:3001',
    sandbox: 'https://api.test.dponet.com.br',
    homol: 'https://api.homol.dponet.com.br',
    production: 'https://api.dponet.com.br',
  },
  marketPlace: {
    development: 'http://api.backoffice.localhost:3012',
    sandbox: 'https://api.backoffice.parceiros.sandbox.dponet.com.br',
    homol: 'https://api.backoffice.parceiros.sandbox.dponet.com.br',
    production: 'https://api.backoffice.parceiros.dponet.com.br',
  },
  website: {
    development: 'https://www.dponet.com.br',
    sandbox: 'https://www.dponet.com.br',
    homol: 'https://www.dponet.com.br',
    production: 'https://www.dponet.com.br',
  },
  cookies: {
    development: 'http://api.localhost:3013',
    sandbox: 'https://cookies.sandbox.dponet.com.br',
    homol: 'https://cookies.sandbox.dponet.com.br',
    production: 'https://cookies.dponet.com.br',
  },
  privacyPortal: {
    development: 'http://localhost:3000',
    sandbox: 'https://www.sandbox.privacidade.com.br',
    homol: 'https://www.sandbox.privacidade.com.br',
    production: 'https://www.privacidade.com.br',
  },
  cookiesCdn: {
    development:
      'https://cdn.cookies.dponet.com.br/banners/4ed3438cf1133102d751d4e4cd2816a9/banner.js',
    sandbox: 'https://test.cdn.cookies.dponet.com.br',
    homol: 'https://cdn.cookies.dponet.com.br',
    production: 'https://cdn.cookies.dponet.com.br',
  },
  ageGateCdn: {
    development: 'https://cdn.cookies.dponet.com.br/development',
    sandbox: 'https://test.cdn.cookies.dponet.com.br',
    homol: 'https://cdn.cookies.dponet.com.br',
    production: 'https://cdn.cookies.dponet.com.br',
  },
  daiRagResources: {
    development: 'http://localhost:8000',
    sandbox: 'https://test-adk-dai-platform-375303226362.us-central1.run.app',
    homol: 'https://homol-adk-dai-platform-375303226362.us-central1.run.app',
    production:
      'https://production-adk-dai-platform-375303226362.us-central1.run.app',
  },
  daiDisputes: {
    development: 'http://localhost:6010',
    sandbox:
      'https://test-dai-governance-dispute-agents-375303226362.us-central1.run.app',
    homol:
      'https://homol-dai-governance-dispute-agents-375303226362.us-central1.run.app',
    production:
      'https://production-dai-governance-dispute-agents-375303226362.us-central1.run.app',
  },
  supplierPortal: {
    development: 'http://api.localhost:3001/suppliers',
    sandbox: 'https://api.test.dponet.com.br/suppliers',
    homol: 'https://api.homol.dponet.com.br/suppliers',
    production: 'https://api.dponet.com.br/suppliers',
  },
  advisorPortal: {
    development: 'http://localhost:3021',
    sandbox: 'https://advisor.test.dponet.com.br',
    homol: 'https://advisor.homol.dponet.com.br',
    production: 'https://advisor.dponet.com.br',
  },
  guestPortal: {
    development: 'http://api.localhost:3001/guests',
    sandbox: 'https://api.test.dponet.com.br/guests',
    homol: 'https://api.homol.dponet.com.br/guests',
    production: 'https://api.dponet.com.br/guests',
  },
  guestPortalWeb: {
    development: 'http://localhost:3002',
    sandbox: 'https://portal.test.dponet.com.br',
    homol: 'https://portal.homol.dponet.com.br',
    production: 'https://portal.dponet.com.br',
  },
  trainingPortal: {
    development: 'http://localhost:3090/api/v1/portal',
    sandbox: 'https://api.test.treinamento.dponet.com.br/api/v1/portal',
    homol: 'https://api.homol.treinamento.dponet.com.br/api/v1/portal',
    production: 'https://api.treinamentos.dponet.com.br/api/v1/portal',
  },
}

const applicationUrl = {
  development: 'http://localhost:3002',
  sandbox: 'https://app.test.dponet.com.br',
  homol: 'https://app.homol.dponet.com.br',
  production: 'https://app.dponet.com.br',
}

const marketPlaceToken = {
  development: 'd556bf32c2b53e1798e7a4f6a3b8226b',
  sandbox: 'd556bf32c2b53e1798e7a4f6a3b8226b',
  homol: 'd556bf32c2b53e1798e7a4f6a3b8226b',
  production: 'd556bf32c2b53e1798e7a4f6a3b8226b',
}

const profilesBaseUrl = {
  development: 'http://localhost:3001/profiles?auth_token_v2=',
  sandbox: 'https://dpms.test.immunizesystem.com/profiles?auth_token_v2=',
  homol: 'https://dpms.homol.immunizesystem.com/profiles?auth_token_v2=',
  production: 'https://dpms.immunizesystem.com/profiles?auth_token_v2=',
}

const tomTicketBaseUrl = {
  development: 'https://dponet.tomticket.com/helpdesk/login?jwt',
  sandbox: 'https://dponet.tomticket.com/helpdesk/login?jwt',
  homol: 'https://dponet.tomticket.com/helpdesk/login?jwt',
  production: 'https://dponet.tomticket.com/helpdesk/login?jwt',
}

const paymentAuthKey = {
  development: 'afb075c950ffb53e02d1389083dadc50',
  sandbox: '36535fe3091f2523aae626fec5dfae68',
  homol: '36535fe3091f2523aae626fec5dfae68',
  production: 'e3fab64d276bf445fe69bc7ff1421f53',
}

const googleAnalyticsTag = {
  development: '',
  sandbox: 'G-579FW2GB8T',
  homol: 'G-579FW2GB8T',
  production: 'G-RSRSGTQL19',
}

const mixPanelAuthKey = {
  development: '9afd4e6a1452acceb1de9c0736505de7',
  sandbox: '9afd4e6a1452acceb1de9c0736505de7',
  homol: '9afd4e6a1452acceb1de9c0736505de7',
  production: '6c206c8e6614b19120cf3f2640b7ff5c',
}

const googleRecaptchaToken = {
  development: '6LcUO9wlAAAAAFP4FAWvGoNeWOtbK-yCq40eKOvC',
  sandbox: '6LcUO9wlAAAAAFP4FAWvGoNeWOtbK-yCq40eKOvC',
  homol: '6LcUO9wlAAAAAFP4FAWvGoNeWOtbK-yCq40eKOvC',
  production: '6LfkOdwlAAAAAKtuo2MBKEEFkn9BRr9wvEPRu_6Y',
}

const editorTyneMceToken = {
  development: 'mhfqqnu8h9sdp9poi354uh2bqva111r9vm65bhe462kyux5i',
  sandbox: '04cwdxlxaqi28ar132hvaii2e6v6lmmk8z11ccd3nms3bscj',
  homol: '04cwdxlxaqi28ar132hvaii2e6v6lmmk8z11ccd3nms3bscj',
  production: '04cwdxlxaqi28ar132hvaii2e6v6lmmk8z11ccd3nms3bscj',
}

const sentryDsn = {
  development:
    'https://3dbbae5ad7ffa0cfbb84a7f5ca46319b@o4506654783176704.ingest.sentry.io/4506654796677120',
  sandbox:
    'https://d935f6ac97ed5dde6c72a029167a1273@o4506654783176704.ingest.sentry.io/4506667497357312',
  homol:
    'https://d935f6ac97ed5dde6c72a029167a1273@o4506654783176704.ingest.sentry.io/4506667497357312',
  production:
    'https://a14d8ee7d9d801818c1acdaf9fc4a003@o4506756782620672.ingest.sentry.io/4506756820893696',
}

const googleAuthenticationToken = {
  development:
    '1074917170118-okvn8qfjvm125suamaomem3io5rchb38.apps.googleusercontent.com',
  sandbox:
    '1074917170118-o7s74av5nunhp8qp8baq8rinr4h76v3l.apps.googleusercontent.com',
  homol:
    '1074917170118-o7s74av5nunhp8qp8baq8rinr4h76v3l.apps.googleusercontent.com',
  production:
    '1074917170118-o7s74av5nunhp8qp8baq8rinr4h76v3l.apps.googleusercontent.com',
}

const microsoftClientId = {
  development: '81e9566d-fa2e-4ec1-8325-a8bfae494abb',
  sandbox: '511db503-cb1e-42ab-a08f-dc01f08dfb16',
  homol: '511db503-cb1e-42ab-a08f-dc01f08dfb16',
  production: '73a999cd-71d6-4665-9300-bfa8d385c067',
}
